import { useQuery } from "react-query";
import { useIvideon } from "./useIvideon";
import { useState } from "react";
import { IvideonHistoryCamerasIProps } from "../model/schema";

export const useGetIvideonHistoryCameras = () => {
  const [params, setParams] = useState<IvideonHistoryCamerasIProps>();
  const { getIvideonHistoryCameras } = useIvideon();

  const getParams = (props: IvideonHistoryCamerasIProps) => {
    setParams(props);
  };

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["getIvideonHistoryCameras", JSON.stringify(params)],
    queryFn: () => getIvideonHistoryCameras(params!),
    onError: (error) => {
      console.log(error);
    },
    enabled: !!params,
  });

  return { data, isLoading, isError, refetch, getParams };
};
